import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import { ModalContext } from "components/ModalContext";
import { CSSTransition } from "react-transition-group";
import "./index.scss";
import { dragAndDropElement } from "../../../utils/helpers";
import { FullScreenAwarePortal } from "components/FullScreenAwarePortal/FullScreenAwarePortal";
const Modal = ({
  onCloseModal,
}) => {
  const { 
    modalContent,
    handleModal, 
    modal,
    isDragAndDrop
  } = React.useContext(ModalContext);

  const modalContentElement = useRef();
  const modalMovableElement = useRef();

  useEffect(() => {
    if(modalContentElement.current && isDragAndDrop) {
      dragAndDropElement(modalContentElement.current, modalMovableElement.current);
    }
  }, [modal]);

  useEffect(() => {
    const body = document.body;
    
    modal
      ? (body.style.overflow = "hidden")
      : (body.style.overflow = "unset");
  }, [modal]);

  const handleCloseModal = (e) => {
    if (
      [...e.target.classList].includes('modal_wrap')
      || [...e.target.classList].includes('modal_close')
    ) {
      handleModal();
      onCloseModal();
    }
  };

   return <FullScreenAwarePortal visible={modal} htmlElementId={"modals"}>
    <CSSTransition
      in={!!modal}
      timeout={300}
      classNames="modal_wrap"
      unmountOnExit
      >
      <>
        <div
          className="modal_wrap"
          onClick={handleCloseModal}
          style={isDragAndDrop && {background: "none", pointerEvents: "none"}}
        >
          <div
            className="modal_content"
            ref={modalContentElement}
            style={isDragAndDrop && {pointerEvents: "auto"}}
          >
           {isDragAndDrop && <div className="movable_panel" ref={modalMovableElement}></div>}
            <button
              className="modal_close"
              onClick={handleCloseModal}
              >
              &times;
            </button>
            <div
              className="modal_content_body"
            >
              {modalContent}
            </div>
          </div>
        </div>
      </>
    </CSSTransition>,
  </FullScreenAwarePortal>
};

export default Modal;
